import { observer } from 'mobx-react-lite';
import React, { Fragment, useContext } from 'react'
import { Modal } from 'semantic-ui-react'
import { RootStoreContext } from '../../stores/RootStore'
import ModalLoadingComponent from './ModalLoadingComponent';

const ModalContainer = () => {
  const rootStore = useContext(RootStoreContext);
  const { modal: { open, body, size }, closeModal, loadingModal } = rootStore.modalStore;

  return (
    <Fragment>

      <Modal
        onClose={closeModal}
        open={open}
        size={size}
      >
        <ModalLoadingComponent active={loadingModal} content='processing...' />
        <Modal.Content >
          {body}
        </Modal.Content>

      </Modal>

    </Fragment>
  );
};

export default observer(ModalContainer);